module.exports = __webpack_public_path__ + "img/szjc16.9671006c.png";